import axios from "./Axios";

class AbstractGraphQL {
    
    static async request(query, variables, headers = {}) {
        if(!this.url){
            throw new Error('URL must be defined!');
        }
        const response = await axios().post(this.url, { query, variables }, {
            headers
        });
        return response['data'];
    }

    static setURL(url){
        this.url = url;
    }

}

export default AbstractGraphQL